<script setup lang="ts">
import { client } from '@shared/openapi/delivery-api/services.gen';
import Snackbar from '@shared/components/Snackbar.vue';
import sharedStores from '@shared/shared-stores';

const { count } = sharedStores.loading.state;

const BASE_URL_API = (import.meta as any).env.VITE_DELIVERY_API_URL;

client.setConfig({
  baseURL: BASE_URL_API
});
</script>

<template>
  <v-app>
    <v-progress-linear
      v-if="count > 0"
      indeterminate
      color="primary"
      class="global-progress-linear"
    ></v-progress-linear>
    <Snackbar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
